export enum SharedRoutingParams {
  /**
   * Query parameter used to specify the page of a list being viewed. Used by the ListComponent
   */
  Page = 'page',
  /**
   * Path parameter to determine which sub-view to load. Used by the DetailsComponent
   */
  Action = 'action',
}
